import { updateItems } from '@/mocks/comics';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最新动态</h2>
            <p className="text-sm text-foreground-500">皮皮漫画站内更新与活动速递</p>
          </div>
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200 hidden sm:block"></div>
            <div className="space-y-5">
              {updateItems.map((item, i) => (
                <div key={i} className="flex gap-4 sm:gap-6">
                  <div className="hidden sm:flex w-10 h-10 rounded-full bg-background-50 border-2 border-background-200 items-center justify-center flex-shrink-0 relative z-10">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 border border-background-200/70">
                    <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                      <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.date}</span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}